<template>

  <div class="ue-expenses-edit">
    <el-card>
      <div class="header">
        <h2>123-2.1.6.4.9.3 огпо перевозка  (Год: {{ dto.trancheYear }}, МРП: {{ dto.mrpValue }})</h2>
        <div>
          <el-button @click="goBack">Назад</el-button>
          <el-button type="primary" @click="submitForm()" :loading="isLoading" v-if="dto.status !== 'APPROVED' && hasEditPermission()">Сохранить</el-button>
        </div>
      </div>

      <form >


        <div class="col-md-12" v-if="getNotAddedRegions().length > 0">
          <div class="row col-md-9">
            <div class="el-input-group">
              <label for="lastname" class="form-label col-md-5">
                В таблицу добавить регион
              </label>
              <div class="col-md-7">
                <select v-model="selectedRegion" id="category"
                        class="form-select">
                  <option v-for="item in getNotAddedRegions()" :key="item.id" :value="item">
                    {{ item.nameRu }}
                  </option>
                </select>

              </div>

              <div class="col-md-2">
                <b-button variant="success" class="btn-sm" style="margin-left: 20px; margin-top: 2px;"
                          :disabled="!selectedRegion"
                          @click="addSelectedRegionInfo()">
                  Добавить
                </b-button>
              </div>
            </div>
          </div>
        </div>

        <div class="table-container">

          <table class="grid-table">
            <thead>
            <tr>

              <th  class="title-cell" rowspan="2">Тип транспортного средства/ Наименование региона</th>
              <th colspan="8">Количество транспортных средств</th>
              <th rowspan="2">Расчетная  сумма					</th>
              <th rowspan="2">Фактическая  сумма					</th>
              <th rowspan="2"></th>
            </tr>
            <tr>
              <th>Легковые автомобили, автобусы, микроавтобусы</th>
              <th>до 4 пассажирских мест включительно</th>
              <th>свыше 4 до 7 пассажирски</th>
              <th>х мест включительно</th>
              <th>свыше 7 до 16 пассажирских мест включительно</th>
              <th>свыше 16 до 30 пассажирских мест включительно</th>
              <th>свыше 30 пассажирских мест</th>
              <th>Трамваи, троллейбусы</th>
            </tr>
            </thead>
            <tbody>
            <tr class="total-row calculated-row readonly-text">
              <td>ВСЕГО</td>
              <td>{{ formatNum(dto.carsBusesMinibuses) }}</td>
              <td>{{ formatNum(dto.seats0To4) }}</td>
              <td>{{ formatNum(dto.seats5To7) }}</td>
              <td>{{ formatNum(dto.seatsX) }}</td>
              <td>{{ formatNum(dto.seats8To16) }}</td>
              <td>{{ formatNum(dto.seats17To30) }}</td>
              <td>{{ formatNum(dto.seatsOver30) }}</td>
              <td>{{ formatNum(dto.tramsTrolleybuses) }}</td>
              <td>{{ formatNum(dto.totalCalculatedSum) }}</td>
              <td>{{ formatNum(dto.totalActualSum) }}</td>
              <td></td>
            </tr>
            <tr v-for="month in dto.months" :key="'m-'+month.month">
              <td>{{ months[month.month - 1] }}</td>
              <td class="readonly-text"></td>
              <td class="readonly-text"></td>
              <td class="readonly-text"></td>
              <td class="readonly-text"></td>
              <td class="readonly-text"></td>
              <td class="readonly-text"></td>
              <td class="readonly-text"></td>
              <td class="readonly-text"></td>
              <td class="readonly-text">{{ formatNum(month.calculatedSum) }}</td>
              <td class="expense-sum-edit">
                <el-input v-model="month.actualSum" type="number" min="0" @input="onMonthActualSumInput(month)"/>
              </td>
              <td></td>
            </tr>

            <tr>
              <td class="title-cell"><b>Размер Коэффициента годовой страховой премии*</b></td>
              <td class="expense-sum-edit">
                <el-input v-model="dto.carsBusesMinibusesCoef" type="number" min="0" @input="recalculateAll()"/>
              </td>
              <td class="expense-sum-edit">
                <el-input v-model="dto.seats0To4Coef" type="number" min="0" @input="recalculateAll()"/>
              </td>
              <td class="expense-sum-edit">
                <el-input v-model="dto.seats5To7Coef" type="number" min="0" @input="recalculateAll()"/>
              </td>
              <td class="expense-sum-edit">
                <el-input v-model="dto.seatsXCoef" type="number" min="0" @input="recalculateAll()"/>
              </td>
              <td class="expense-sum-edit">
                <el-input v-model="dto.seats8To16Coef" type="number" min="0" @input="recalculateAll()"/>
              </td>
              <td class="expense-sum-edit">
                <el-input v-model="dto.seats17To30Coef" type="number" min="0" @input="recalculateAll()"/>
              </td>
              <td class="expense-sum-edit">
                <el-input v-model="dto.seatsOver30Coef" type="number" min="0" @input="recalculateAll()"/>
              </td>
              <td class="expense-sum-edit">
                <el-input v-model="dto.tramsTrolleybusesCoef" type="number" min="0" @input="recalculateAll()"/>
              </td>
              <td class="readonly-text"></td>
              <td class="readonly-text"></td>
              <td></td>
            </tr>

            <template v-for="region in dto.regions" :key="region.uuid || region.regionId">
              <tr>
                <td class="title-cell"><b>{{ region.region?.nameRu }}</b></td>
                <td class="expense-sum-edit">
                  <el-input v-model="region.carsBusesMinibuses" type="number" min="0" @input="recalculateAll()"/>
                </td>
                <td class="expense-sum-edit">
                  <el-input v-model="region.seats0To4" type="number" min="0" @input="recalculateAll()"/>
                </td>
                <td class="expense-sum-edit">
                  <el-input v-model="region.seats5To7" type="number" min="0" @input="recalculateAll()"/>
                </td>
                <td class="expense-sum-edit">
                  <el-input v-model="region.seatsX" type="number" min="0" @input="recalculateAll()"/>
                </td>
                <td class="expense-sum-edit">
                  <el-input v-model="region.seats8To16" type="number" min="0" @input="recalculateAll()"/>
                </td>
                <td class="expense-sum-edit">
                  <el-input v-model="region.seats17To30" type="number" min="0" @input="recalculateAll()"/>
                </td>
                <td class="expense-sum-edit">
                  <el-input v-model="region.seatsOver30" type="number" min="0" @input="recalculateAll()"/>
                </td>
                <td class="expense-sum-edit">
                  <el-input v-model="region.tramsTrolleybuses" type="number" min="0" @input="recalculateAll()"/>
                </td>
                <td class="readonly-text"></td>
                <td class="readonly-text"></td>
                <td>
                  <el-button type="text" class="btn-icon color-red"
                             @click="onClickRemove(region)">
                    <font-awesome-icon :icon="['fas', 'cancel']"/>
                  </el-button>
                </td>
              </tr>
            </template>

            <tr class="total-row calculated-row">
              <td>Сумма взноса **</td>
              <td class="expense-sum-edit">
                <el-input v-model="dto.carsBusesMinibuses" type="number" min="0"/>
              </td>
              <td class="expense-sum-edit">
                <el-input v-model="dto.seats0To4" type="number" min="0"/>
              </td>
              <td class="expense-sum-edit">
                <el-input v-model="dto.seats5To7" type="number" min="0"/>
              </td>
              <td class="expense-sum-edit">
                <el-input v-model="dto.seatsX" type="number" min="0"/>
              </td>
              <td class="expense-sum-edit">
                <el-input v-model="dto.seats8To16" type="number" min="0"/>
              </td>
              <td class="expense-sum-edit">
                <el-input v-model="dto.seats17To30" type="number" min="0"/>
              </td>
              <td class="expense-sum-edit">
                <el-input v-model="dto.seatsOver30" type="number" min="0"/>
              </td>
              <td class="expense-sum-edit">
                <el-input v-model="dto.tramsTrolleybuses" type="number" min="0"/>
              </td>
              <td class="expense-sum-edit">
                <el-input v-model="dto.calculatedSum" type="number" min="0" @input="onContributionCalcSumChange()"/>
              </td>
              <td class="readonly-text"></td>
              <td></td>
            </tr>
            </tbody>

          </table>
        </div>


      </form>
      </el-card>
  </div>


  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script>

import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import {showErrorNotify, showSuccessNotify} from "@/utils/notificationUtils";
import delegationService from "@/services/delegationService";
import authService from "@/services/authService";
import ueExpensesCommonCrudService from "@/services/expenses/ueExpensesCommonCrudService";
import regionService from "@/services/regionService";

export default {
  components: {
    VueLoading
  },
  computed: {
    uuid() {
      return this.$route.params.uuid;
    }
  },
  data() {
    return {
      isLoading: false,
      expenseType: 'insurance-transfer',
      dto: {
        uuid: null,
        trancheYear: null,
        universityId: null,
        months: []
      },
      months: [
        'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
        'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
      ],
      selectedRegion: null,
      regions: [],
      managerRoles: authService.getManagerRoles(),
      universityManagerRoles: authService.getUniversityManagerRoles(),
    };
  },
  methods: {
    async init() {
      this.isLoading = true;
      try {
        await this.findById(this.uuid);
        await this.getRegions();
        this.recalculateAll();
      } finally {
        this.isLoading = false;
      }
    },

    async getRegions() {
      const params = {
        partNumber: 1,
        countInPage: 0,
        filter: {}
      };
      const response = await regionService.getAll(params);
      this.regions = response.list.sort((a, b) => a.nameRu.localeCompare(b.nameRu));
    },

    getNotAddedRegions() {
      if (!this.dto.regions) {
        return this.regions;
      }
      if (this.dto.regions.length >= this.regions.length) {
        return [];
      }
      const addedItems = this.dto.regions.map(c => c.region.id);
      return this.regions.filter(item => !addedItems.includes(item.id));
    },

    addSelectedRegionInfo() {
      if (!this.dto.regions) {
        this.dto.regions = [];
      }
      this.dto.regions.push({
        region: this.selectedRegion,
        regionId: this.selectedRegion.id
      });
      this.selectedRegion = null;
    },

    async findById(uuid) {
      this.dto = await ueExpensesCommonCrudService.findById(this.expenseType, uuid);
      this.initFrontendFields();
      this.sortByCatAndMonth();
    },

    initFrontendFields() {
      this.dto.totalCalculatedSum = 0;
      this.dto.totalActualSum = 0;
    },

    async submitForm() {
      try {
        if (!this.hasEditPermission()) return;
        this.isLoading = true;
        this.dto = await ueExpensesCommonCrudService.save(this.expenseType, this.dto);
        this.initFrontendFields();
        this.sortByCatAndMonth();
        this.recalculateAll();
        showSuccessNotify("Успешно сохранено!");
      } catch (exc) {
        showErrorNotify("Возникла ошибка при сохранении");
      } finally {
        this.isLoading = false;
      }
    },

    sortByCatAndMonth() {
      if (this.dto.months) {
        this.dto.months.sort((a, b) => a.month - b.month);
      }
    },

    recalculateAll() {
      const fields = ['carsBusesMinibuses', 'seats0To4', 'seats5To7', 'seatsX',
        'seats8To16', 'seats17To30', 'seatsOver30', 'tramsTrolleybuses'];
      const mrp = Math.max(0, parseFloat(this.dto.mrpValue || 0));

      // Region calculatedSum = sum of (vehicle_count × coef × MRP) per region (display only)
      for (const region of (this.dto.regions || [])) {
        region.calculatedSum = fields.reduce((sum, f) => {
          const count = Math.max(0, parseFloat(region[f] || 0));
          const coef = Math.max(0, parseFloat(this.dto[f + 'Coef'] || 0));
          return sum + count * coef * mrp;
        }, 0);
      }

      // calculatedSumCoef = sum of all vehicle coefs (readonly display)
      this.dto.calculatedSumCoef = fields.reduce((sum, f) =>
        sum + Math.max(0, parseFloat(this.dto[f + 'Coef'] || 0)), 0);

      // Сумма взноса (dto.* vehicle fields + dto.calculatedSum) is manual — not overwritten here

      this.recalculateMonths();
    },

    recalculateMonths() {
      // Month calculatedSum = YELLOW / 12
      const monthCalc = Math.round(parseFloat(this.dto.calculatedSum || 0) / 12 * 100) / 100;
      for (const month of (this.dto.months || [])) {
        month.calculatedSum = monthCalc;
        month.actualSum = monthCalc;
      }

      // ВСЕГО = sum of months
      this.dto.totalCalculatedSum = (this.dto.months || []).reduce(
        (sum, m) => sum + parseFloat(m.calculatedSum || 0), 0);
      this.dto.totalActualSum = (this.dto.months || []).reduce(
        (sum, m) => sum + parseFloat(m.actualSum || 0), 0);
      this.dto.actualSum = this.dto.totalActualSum;
    },

    onContributionCalcSumChange() {
      if (parseFloat(this.dto.calculatedSum) < 0) {
        this.dto.calculatedSum = 0;
      }
      this.recalculateMonths();
    },

    onMonthActualSumInput(month) {
      if (parseFloat(month.actualSum) < 0) {
        month.actualSum = 0;
      }
      this.dto.totalActualSum = (this.dto.months || []).reduce(
        (sum, m) => sum + parseFloat(m.actualSum || 0), 0);
      this.dto.actualSum = this.dto.totalActualSum;
    },

    formatNum(val) {
      if (val === undefined || val === null || val === '') return '';
      const num = parseFloat(val);
      if (isNaN(num)) return '';
      if (num === 0) return '0,00';
      return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ' ').replace('.', ',');
    },

    goBack() {
      this.$router.go(-1);
    },

    hasEditPermission() {
      return this.isUniversityManager() && (this.dto.status === 'CREATED' || !this.dto.status);
    },

    isUniversityManager() {
      return delegationService.isUniversityManager();
    },

    async onClickRemove(region) {
      const confirmed = await confirm("Вы уверены, что хотите удалить этот элемент?");
      if (confirmed) {
        try {
          await ueExpensesCommonCrudService.deleteCategory(this.expenseType, this.uuid, region.uuid);
          this.init();
          showSuccessNotify('Успешно удалено');
        } catch (exc) {
          showErrorNotify('Возникла ошибка при удалении');
        }
      }
    },
  },
  mounted() {
    this.init();
  }
};
</script>

<style scoped>
.row {
  padding-top: 5px;
}

table.expenses-detail tr td {
  padding: 0 !important;
  padding-left: 5px !important;
  font-size: 14px;
}
table.expenses-detail tr td.expense-sum-edit:has(.form-control){
  padding-left: 0 !important;
}

table.expenses-detail tr td.expense-sum-edit .form-control {
  padding-left: 2px !important;
  font-size: 14px !important;
}
.header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; }
.table-container { width: 100%; overflow-x: auto; }
.grid-table { width: 100%; border-collapse: collapse; min-width: 1200px; }
.grid-table th, .grid-table td { border: 1px solid #EBEEF5; padding: 8px; font-size: 13px; }
.grid-table th { background-color: #f5f7fa; text-align: center; font-weight: bold; position: sticky; top: 0; z-index: 10; }
.title-cell { width: 250px; }
.color-red, .color-red:hover {  color: red !important;}
.calculated-row { background-color: #f0f9eb; font-weight: bold; }
.readonly-text { text-align: right; padding-right: 10px !important; }
::v-deep .el-input__inner { text-align: right; font-size: 13px; -moz-appearance: textfield; }
::v-deep .el-input__inner::-webkit-outer-spin-button,
::v-deep .el-input__inner::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }
.total-row td {
  font-weight: bold;
}
</style>
